<ng-template [ngIf]="iframeLoaded">
    <iframe #iframe (load)="loading.emit(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe" *ngIf="sandbox == true" sandbox="allow-scripts allow-same-origin allow-popups"></iframe>
    <iframe #iframe (load)="loading.emit(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe" *ngIf="sandbox == false"></iframe>
</ng-template>
<nts-loader [isVisible]="!iframeLoaded"></nts-loader>
